module.exports = __webpack_public_path__ + "img/82.b043f38a.jpg";